module.exports = __webpack_public_path__ + "public/img/tadiao.906f74c4.png";